// src/hooks/useClientWord.js
// 3.67.5 (owner, Oct 23): what a client is called in list headings and
// filters. "Client" is our word: Super Admins see it. The people at a client
// see "Company" (their own company), never "client".
import { useAuth } from './useAuth';

export function useClientWord() {
  const { effectiveInfo } = useAuth();
  return effectiveInfo?.roleId === 'super_admin' ? 'Client' : 'Company';
}
